
/**
 * log level items.
 *
 * @export
 * @enum {number}
 */
export enum Level {
    log = 'log',
    trace = 'trace',
    debug = 'debug',
    info = 'info',
    warn = 'warn',
    error = 'error',
    fatal = 'fatal'
}

/**
 * log levels
 *
 * @export
 * @enum {number}
 */
export enum Levels {
    trace = 0,
    debug,
    info,
    warn,
    error,
    fatal
}
